<script>
    import { getStorage, ref, getDownloadURL, uploadBytes, uploadString } from "firebase/storage";
    import { user } from "../../firebase/auth";
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
        DialogDescription,
        Transition
    } from "@rgossiaux/svelte-headlessui";
    import { createEventDispatcher, onMount } from "svelte";

    const storage = getStorage();
    const dispatch = createEventDispatcher();

    let canvas;
    let ctx;
    let img;
    let dataurl;

    export let outputDimensions = {x: 200, y: 200}
    let inputDimensions;

    let origin = {};
    let originBounds = {};

    let zoom = 1;
    let zoom_min_contain;
    let zoom_min_cover;

    export let file;

    let open = true;

    onMount(() => {
        console.log(outputDimensions);
        if (file) {
            var reader = new FileReader();
            reader.onload = function (e) {
                img = document.createElement("img");
                img.onload = function (event) {
                    // Create canvas
                    canvas = document.createElement("canvas");
                    canvas.width = outputDimensions.x;
                    canvas.height = outputDimensions.y;
                    ctx = canvas.getContext("2d");
    
                    inputDimensions = {
                        x: img.width,
                        y: img.height
                    };

                    let outputInputRatio = {
                        x: outputDimensions.x/inputDimensions.x,
                        y: outputDimensions.y/inputDimensions.y
                    }

                    zoom_min_contain = Math.min(outputInputRatio.x, outputInputRatio.y);
                    zoom_min_cover = Math.max(outputInputRatio.x, outputInputRatio.y);
                    zoom = zoom_min_cover;

                    // set origin to center
                    origin = {
                        x: inputDimensions.x/2,
                        y: inputDimensions.y/2
                    }

                    updateBounds();
                    draw();
                }
                img.src = e.target.result;
            }
            reader.readAsDataURL(file);
        }
    })


    function center() {
        origin.x = inputDimensions.x/2;
        origin.y = inputDimensions.y/2;
    }

    
    function move(x, y) {
        // apply the movement
        origin.x = origin.x + x;
        origin.y = origin.y + y;
        enforceBounds()
        draw();
    }

    function scale() {
        updateBounds();
        enforceBounds();
        draw();
    }
    
    function updateBounds() {
        originBounds = {
            left: outputDimensions.x / zoom /2,
            right: inputDimensions.x - outputDimensions.x / zoom /2,
            top: outputDimensions.y / zoom /2,
            bottom: inputDimensions.y - outputDimensions.y / zoom /2
        }
        if (originBounds.left > originBounds.right) {
            let center = (originBounds.left + originBounds.right) / 2
            originBounds.left = center;
            originBounds.right = center;
        }
        if (originBounds.top > originBounds.bottom) {
            let center = (originBounds.top + originBounds.bottom) / 2
            originBounds.top = center;
            originBounds.bottom = center;
        }
    }

    function enforceBounds() {
        origin.x = Math.min(Math.max(origin.x, originBounds.left), originBounds.right);
        origin.y = Math.min(Math.max(origin.y, originBounds.top), originBounds.bottom);
    }

    
    function draw() {
        let offset = {
            x: -origin.x*zoom + outputDimensions.x/2,
            y: -origin.y*zoom + outputDimensions.y/2
        }
        let size = {
            x: inputDimensions.x * zoom,
            y: inputDimensions.y * zoom
        }
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.clearRect(offset.x + originBounds.left, offset.y + originBounds.top, 150, 100);
        ctx.drawImage(img, offset.x, offset.y, size.x, size.y);
        dataurl = canvas.toDataURL(file.type);
        document.getElementById("preview").src = dataurl;
    }

    function upload() {
        let name = Date.now()
        let imgPath = "/images/"+$user.uid+"/"+name;
        const storageRef = ref(storage, imgPath);
        uploadString(storageRef, dataurl, 'data_url').then((snapshot) => {
            console.log('Uploaded a data_url string!');
            getDownloadURL(storageRef).then((downloadURL) => {
                file = undefined;
                open = false;
                dispatch("uploadFinished", {
                    src: downloadURL,
                    name: name,
                    path: $user.uid+"/"+name
                })
            });
        });
    }
</script>


<Dialog class="dialog" open={open} on:close={() => {file = undefined; open = false}}>
    <!-- <DialogOverlay class="dialog-overlay"/> -->
    <div class="dialog-content">
        <DialogTitle class="dialog-title">Bild hochladen</DialogTitle>
        <DialogDescription class="dialog-description">
            Wähle den gewünschten Bildausschnitt und lade das Bild anschließend hoch.
        </DialogDescription>

        <div class="columns">
            <div class="img">
                <img alt="preview" id="preview" width={outputDimensions.x} height={outputDimensions.y}/>
            </div>
            <div class="controls">
                <label>Zoom<br>
                    <input type="range" min={zoom_min_contain} max={zoom_min_cover*4} step=0.01 bind:value={zoom} on:input={scale}>
                </label>
                <label>Horizontal verschieben<br>
                    <input type="range" disabled={originBounds.left == originBounds.right} min={originBounds.left} max={originBounds.right} step=0.01 bind:value={origin.x} on:input={draw}>
                </label>
                <label>Vertikal verschieben<br>
                    <input type="range" disabled={originBounds.top == originBounds.bottom} min={originBounds.top} max={originBounds.bottom} step=0.01 bind:value={origin.y} on:input={draw}>
                </label>
            </div>
        </div>
        
        <div class="dialog-options">
            <button on:click={() => {file = undefined; open = false}}>Abbrechen</button>
            <button class="primary" on:click={upload}>Hochladen</button>
        </div>
    </div>
</Dialog>

<style>
    .columns {
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        gap: 1rem;
        margin-bottom: 1rem;
    }

    .img {
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
        font-size: 0;
        height: fit-content;
        height: 200px;
        width: auto;
    }

    img {
        width: 100%;
        height: 100%;
    }

    .controls {
        padding: 1rem;
        flex: 1;
    }

    .controls input {
        width: 100%;
    }
</style>